import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API_BASE = (window.__APP_CONFIG__ && window.__APP_CONFIG__.API_URL) || process.env.REACT_APP_API_URL || '';
if (API_BASE && !axios.defaults.baseURL) {
  axios.defaults.baseURL = API_BASE;
}

const EventList = () => {
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();

  const handleDelete = async (id) => {
    try {
      const ok = window.confirm('Delete this event permanently? This cannot be undone.');
      if (!ok) return;
      await axios.delete(`/api/events/${id}`);
      // Optimistically remove from list
      setEvents(prev => prev.filter(e => e._id !== id));
    } catch (err) {
      console.error('❌ Error deleting event:', err?.response?.data || err.message);
      alert('Delete failed. See console for details.');
    }
  };

  useEffect(() => {
    axios.get('/api/events')
      .then(res => {
        const sorted = res.data.sort((a, b) => {
          // Sort by active status first
          if (a.isActive !== b.isActive) return a.isActive ? -1 : 1;
          // Then sort by start date (descending - recent first)
          return new Date(b.startDate) - new Date(a.startDate);
        });
        setEvents(sorted);
      })
      .catch(err => {
        console.error("❌ Error fetching events:", err);
      });
  }, []);

  const handleEdit = (id) => {
    console.log("🧭 Navigating to edit event:", id);
    navigate(`/events/edit/${id}`);
  };

  return (
    <div className="max-w-5xl mx-auto px-6 py-8">
      <h1 className="text-2xl font-semibold mb-6">📅 Event List</h1>

      {events.length === 0 ? (
        <p className="text-gray-600">No events available.</p>
      ) : (
        <div className="overflow-x-auto rounded shadow">
          <table className="min-w-full bg-white border border-gray-200">
            <thead className="bg-gray-100 text-left">
              <tr>
                <th className="px-4 py-3 border-b text-sm font-medium">Event Name</th>
                <th className="px-4 py-3 border-b text-sm font-medium">Start Date</th>
                <th className="px-4 py-3 border-b text-sm font-medium">End Date</th>
                <th className="px-4 py-3 border-b text-sm font-medium">Event Fee</th>
                <th className="px-4 py-3 border-b text-sm font-medium">Status</th>
                <th className="px-4 py-3 border-b text-sm font-medium">Actions</th>
              </tr>
            </thead>
            <tbody>
              {events.map(event => (
                <tr key={event._id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 border-b">{event.name}</td>
                  <td className="px-4 py-2 border-b">{event.startDate?.slice(0, 10)}</td>
                  <td className="px-4 py-2 border-b">{event.endDate?.slice(0, 10)}</td>
                  <td className="px-4 py-2 border-b">
                    ₹{event.eventFee ?? '—'}
                  </td>
                  <td className="px-4 py-2 border-b">
                    {event.isActive ? (
                      <span className="text-green-600 font-medium">Active</span>
                    ) : (
                      <span className="text-gray-500">Inactive</span>
                    )}
                  </td>
                  <td className="px-4 py-2 border-b whitespace-nowrap">
                    <button
                      onClick={() => handleEdit(event._id)}
                      className="text-blue-600 hover:underline text-sm mr-4"
                    >
                      Edit
                    </button>
                    {!event.isActive && (
                      <button
                        onClick={() => handleDelete(event._id)}
                        className="text-red-600 hover:underline text-sm"
                        title="Delete (inactive only)"
                      >
                        Delete
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default EventList;